import React from 'react'
import Button from './button'
import useClientLocation from '../../../hooks/use-client-location'
import useCurrentUser from '../../../hooks/use-current-user'
import useCourseEnrollability from '../../user/hooks/use-user-course-enrollability'

const PreviewScheduleButton = ({
    experience={},
    visible=true
}) => {
    const { toViewExperienceConflicts } = useClientLocation()
    const { isStudent } = useCurrentUser()
    const { isLoadingEnrollability, conflicts } = useCourseEnrollability({ courseId: experience.id })
    if (!visible || !isStudent || isLoadingEnrollability || !conflicts.length) {
        return null
    }

    return (
        <Button
            block
            size='lg'
            onClick={() => toViewExperienceConflicts()}
        >
            VIEW CONFLICTS
        </Button>
    )
}

export default PreviewScheduleButton
